import { getUrlParameter } from 'helpers/Url'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './Pagination.scss'

const currentPage = (self) => getUrlParameter(self, 'page')
const lastPage = (last, self) =>
  getUrlParameter(last, 'page') || currentPage(self)

const shouldRender = (display, next, prev) => {
  if (!display) {
    return false
  }

  if (!prev && !next) {
    return false
  }

  return true
}

export const Pagination = ({ t, display, links, onPageChange }) => {
  if (!links || !shouldRender(display, links.next, links.prev)) {
    return null
  }

  return (
    <div className="c-projects-pagination">
      <button
        className="c-projects-pagination__link c-projects-pagination__link--prev"
        onClick={() => onPageChange(links.prev)}
        disabled={!links.prev}
      >
        <span className="u-visually-hidden">{t('projects.prevPage')}</span>
      </button>

      <span className="c-projects-pagination__label">
        {t('projects.pagination', {
          page: currentPage(links.self),
          totalPages: lastPage(links.last, links.self),
        })}
      </span>

      <button
        className="c-projects-pagination__link c-projects-pagination__link--next"
        onClick={() => onPageChange(links.next)}
        disabled={!links.next}
      >
        <span className="u-visually-hidden">{t('projects.nextPage')}</span>
      </button>
    </div>
  )
}

Pagination.propTypes = {
  display: PropTypes.bool.isRequired,
  links: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation('translations')(Pagination)
